/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useMemo, useState } from 'react';
import { Alert, Button, IconButton, LinearProgress, Pagination, Paper, Snackbar, SnackbarCloseReason, Switch, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Box, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

import { Environment } from '../../../shared/environment';
import dayjs, { Dayjs } from 'dayjs';
import { FerramentasDaListagemFinanceiroConciliacao } from '../../../shared/components';
import { CaixaConstasService, IListagem, IResultado, IVoltarLancamento } from '../../../shared/services/api/Financeiro/Caixa';
import { LayoutBaseDeFinanceiroConciliacao } from '../../../shared/layouts';
import ReplyIcon from '@mui/icons-material/Reply';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import RepeatIcon from '@mui/icons-material/Repeat';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import PDFCaixa from './Impressaocaixa';
import { DialoFecharCaixa } from './DialogFecharCaixa';
import { DialogAbrirCaixa } from './DialogAbrirCaixa';
import EngineeringIcon from '@mui/icons-material/Engineering';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

export const Conciliacao: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [rows, setRows] = useState<IListagem[]>([]);
  const [rowsVoltar, setRowsVoltar] = useState<IVoltarLancamento | undefined>(undefined);
  const [resultados, setResultados] = useState<IResultado | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [openFechar, setOpenFechar] = useState(false);  
  const [openAbrir, setOpenAbrir] = useState(false);  
  const [dataInicial, setDataInicial] = useState(dayjs().format('DD/MM/YYYY')); 
  const [dataFinal, setDataFinal] = useState(dayjs().format('DD/MM/YYYY'));  
  const [status, setStatus] = useState(false); 
  const [conta, setConta] = useState('');
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');  
        
  const [openConfirm, setOpenConfirm] = useState(false);
  
  // Estado para controlar se a conta já foi selecionada e pesquisada
  const [contaSelecionada, setContaSelecionada] = useState('');
  const [descricaoContaSelecionada, setDescricaoContaSelecionada] = useState('');
  
  // Estado para controlar se já foi realizada uma pesquisa
  const [pesquisaRealizada, setPesquisaRealizada] = useState(false);
          
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event, 
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
    if(tms === 'success'){ 
      // navigate('/contabancaria');
    }
  };
        
  const handleVoltar = (idoperacao: string, datacaixa: Date, idconta: string, tipo: number) => {
    const voltarlancamento = {
      idoperacao: idoperacao,
      datacaixa: datacaixa,
      idconta: idconta,
      tipos: tipo,
    };
    setRowsVoltar(voltarlancamento);
    setOpenConfirm(true); 
  };
        
  const handleConfirmDelete = () => {
    if (typeof rowsVoltar === 'object') {
      CaixaConstasService
        .VoltarLancamento(rowsVoltar)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setOpenConfirm(false);
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          }else{
            setIsLoading(true);    
            if(contaSelecionada != ''){ 
              setConta(descricaoContaSelecionada);
              CaixaConstasService.getAll('', contaSelecionada, dataInicial, dataFinal)
                .then((result) => {
                  setIsLoading(false);  
                  if (result instanceof Error) {
                    setOpenConfirm(false);
                    setTms('error');
                    setMsg(result.message);
                    setOpenmsg(true);
                  } else { 
                    setTotalCount(result.totalCount);
                    if(result.lan.length > 0){
                      setRows(result.lan);
                      setStatus(result.lan[0].status);
                      setPesquisaRealizada(true);
                    }else{
                      setRows([]);
                      setStatus(false);
                      setPesquisaRealizada(true);
                    }          
                    if (typeof result.resultado === 'object') 
                      setResultados(result.resultado);
                  }
                  setOpenConfirm(false);
                  setTms('success');
                  setMsg('Baixa do caixa desfeita com sucesso.');
                  setOpenmsg(true);
                });
            }     
          }
        });
    }
  
  };
        
  const handleCancelDelete = () => {
    setOpenConfirm(false);
  };
            
  const pagina = useMemo(() => {
    return Number(searchParams.get('pagina') || '1');
  }, [searchParams]);  

  // Função para quando selecionar a conta (apenas guarda a seleção)
  const handleSelecionarConta = (idconta: string, descricao: string) => {
    setContaSelecionada(idconta);
    setDescricaoContaSelecionada(descricao);
    // Limpa os resultados anteriores
    setRows([]);
    setResultados(undefined);
    setStatus(false);
    setPesquisaRealizada(false);
    // Atualiza a URL sem recarregar a página
    setSearchParams({ conta: idconta, descricaoconta: descricao, pagina: '1' }, { replace: true });
  };

  // Função para pesquisar (chamada pelo botão pesquisar)
  const handlePesquisar = () => {
    if(contaSelecionada === '') {
      setTms('warning');
      setMsg('Selecione uma conta antes de pesquisar');
      setOpenmsg(true);
      return;
    }
    
    setIsLoading(true);
    setConta(descricaoContaSelecionada);
    CaixaConstasService.getAll('', contaSelecionada, dataInicial, dataFinal)
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
          setPesquisaRealizada(true);
        } else {
          setTotalCount(result.totalCount);
          if(result.lan.length > 0){
            setRows(result.lan);
            setStatus(result.lan[0].status);
          } else {
            setRows([]);
            setStatus(false);
          }
          setPesquisaRealizada(true);
          if (typeof result.resultado === 'object') 
            setResultados(result.resultado);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setTms('error');
        setMsg('Erro ao carregar os dados');
        setOpenmsg(true);
        setPesquisaRealizada(true);
      });
  };

  // Efeito apenas para quando mudar a página após já ter pesquisado
  useEffect(() => {
    if(contaSelecionada !== '' && pesquisaRealizada && rows.length > 0) {
      setIsLoading(true);
      CaixaConstasService.getAll('', contaSelecionada, dataInicial, dataFinal)
        .then((result) => {
          setIsLoading(false);
          if (!(result instanceof Error)) {
            setTotalCount(result.totalCount);
            setRows(result.lan);
            if (result.lan && result.lan.length > 0) {
              setStatus(result.lan[0].status);
            }
            if (typeof result.resultado === 'object') 
              setResultados(result.resultado);
          }
        });
    }
  }, [pagina]);
          
  const handleClose = (newValue?: string) => {
    setOpenAbrir(false); 
    setOpenFechar(false);  
    if (newValue === 'true') {
      if(contaSelecionada != ''){
        setConta(descricaoContaSelecionada);
        setIsLoading(true);  
        CaixaConstasService.getAll('', contaSelecionada, dataInicial, dataFinal)
          .then((result) => {
            setIsLoading(false);  
            if (result instanceof Error) {
              setTms('error');
              setMsg(result.message);
              setOpenmsg(true);
            } else { 
              setTotalCount(result.totalCount);
              setRows(result.lan);
              if(result.lan.length > 0){
                setStatus(result.lan[0].status);
              } else {
                setStatus(false);
              }
              setPesquisaRealizada(true);
              if (typeof result.resultado === 'object') 
                setResultados(result.resultado);
            }
          });
      }
    }
  };  

  const handlePesquisa = (datainicial: Dayjs | null, datafinal: Dayjs | null) => {
    const formattedDateInicial = datainicial ? dayjs(datainicial).format('DD/MM/YYYY') : '';
    const formattedDateFinal = datafinal ? dayjs(datafinal).format('DD/MM/YYYY') : '';
    setDataInicial(formattedDateInicial);
    setDataFinal(formattedDateFinal);
    
    if(contaSelecionada === '') {
      setTms('warning');
      setMsg('Selecione uma conta antes de pesquisar');
      setOpenmsg(true);
      return;
    }
    
    setIsLoading(true);    
    setConta(descricaoContaSelecionada);
    CaixaConstasService.getAll('', contaSelecionada, formattedDateInicial, formattedDateFinal)
      .then((result) => {
        setIsLoading(false);  
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
          setPesquisaRealizada(true);
        } else { 
          setTotalCount(result.totalCount);
          if(result.lan.length > 0){
            setRows(result.lan);
            setStatus(result.lan[0].status);  
          }else{
            setRows([]);
            setStatus(false);  
          }
          setPesquisaRealizada(true);
          if (typeof result.resultado === 'object') 
            setResultados(result.resultado);
        }
      });
  };   

  const handlePrint = () => {
    setIsLoading(true);    
    
    if(contaSelecionada != ''){ 
      setConta(descricaoContaSelecionada);
      CaixaConstasService.getAll('impressao', contaSelecionada, dataInicial, dataFinal)
        .then((result) => {
          setIsLoading(false);  
          if (result instanceof Error) {
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            if(result.lan.length > 0){
              if (typeof result.resultado === 'object')
              console.log(result.lan);
              PDFCaixa(result.lan, result.resultado, conta);
            } else {
              setTms('warning');
              setMsg('Não há dados para imprimir');
              setOpenmsg(true);
            }
          }
        });
    } else {
      setTms('warning');
      setMsg('Selecione uma conta para imprimir');
      setOpenmsg(true);
      setIsLoading(false);
    }
  };    

  const handleFechar = () => {
    if(contaSelecionada === '') {
      setTms('warning');
      setMsg('Selecione uma conta para fechar');
      setOpenmsg(true);
      return;
    }
    setOpenFechar(true);
  };

  const handleAbrir = () => {
    if(contaSelecionada === '') {
      setTms('warning');
      setMsg('Selecione uma conta para abrir');
      setOpenmsg(true);
      return;
    }
    setOpenAbrir(true);
  };
   
  return (
    <LayoutBaseDeFinanceiroConciliacao
      titulo='Conciliação'
      saldoanterior={resultados?.saldoanterior ? resultados.saldoanterior.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0,00'}
      credito={resultados?.credito ? resultados.credito.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0,00'}
      debito={resultados?.debito ? resultados.debito.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0,00'}
      saldo={resultados?.saldo ? resultados.saldo.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0,00'}
      cheque={resultados?.valorcheque ? resultados.valorcheque.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0,00'}
      saldoreal={resultados?.saldoreal ? resultados.saldoreal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0,00'}
      barraDeFerramentas={
        <FerramentasDaListagemFinanceiroConciliacao
          mostrarBotaoAbrirConta={status ? true : false}
          mostrarBotaoFecharConta={status ? false : true}
          aoClicarEmFecharConta={handleFechar}
          aoClicarEmImpressao={handlePrint}
          aoClicarEmAbrirConta={handleAbrir}
          aoClicarEmPesquisa={handlePesquisa}
          aoMudarTextoDoIdconta={handleSelecionarConta}
        />
      }
    >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <Snackbar open={openConfirm} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert
          severity="warning"  
          variant="filled"
          sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
          action={
            <>
              <Button color="inherit" size="small" onClick={handleConfirmDelete}>
              Sim
              </Button>
              <Button color="inherit" size="small" onClick={handleCancelDelete}>
              Não
              </Button>
            </>
          }
        >
          Realmente deseja Voltar Este Lançamento?
        </Alert>
      </Snackbar>
      
      {/* Loading Indicator */}
      {isLoading && (
        <LinearProgress sx={{ mx: 1, my: 0 }} />
      )}
      
      {/* Table Container with Scroll only inside the table */}
      <Box sx={{ height: 'calc(100vh - 320px)', display: 'flex', flexDirection: 'column', mx: 1 }}>
        <TableContainer 
          component={Paper} 
          variant="outlined" 
          sx={{ 
            flex: 1,
            overflow: 'auto',
            '&::-webkit-scrollbar': {
              width: '8px',
              height: '8px',
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: (theme) => theme.palette.grey[200],
              borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: (theme) => theme.palette.grey[400],
              borderRadius: '4px',
              '&:hover': {
                backgroundColor: (theme) => theme.palette.grey[500],
              },
            },
          }}
        >
          <Table stickyHeader>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ backgroundColor: (theme) => theme.palette.background.paper, py: 1 }}></TableCell>
                  <TableCell sx={{ backgroundColor: (theme) => theme.palette.background.paper, py: 1 }}>Data</TableCell>
                  <TableCell align='center' sx={{ backgroundColor: (theme) => theme.palette.background.paper, py: 1 }}>Numero</TableCell>
                  <TableCell align='left' sx={{ backgroundColor: (theme) => theme.palette.background.paper, py: 1 }}>Parceiro</TableCell>
                  <TableCell align='left' sx={{ backgroundColor: (theme) => theme.palette.background.paper, py: 1 }}>Histórico</TableCell>
                  <TableCell align='right' sx={{ backgroundColor: (theme) => theme.palette.background.paper, py: 1 }}>Crédito</TableCell>
                  <TableCell align='right' sx={{ backgroundColor: (theme) => theme.palette.background.paper, py: 1 }}>Débito</TableCell>
                  <TableCell sx={{ maxWidth: 15, width:15, backgroundColor: (theme) => theme.palette.background.paper, py: 1 }} align='center'></TableCell>
                </TableRow>
              </TableHead>    
              <TableBody>
                {!pesquisaRealizada ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center" sx={{ py: 8 }}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                        <AccountBalanceIcon sx={{ fontSize: 64, color: (theme) => theme.palette.grey[400] }} />
                        <Typography variant="h6" color="textSecondary">
                          {!contaSelecionada ? 'Selecione uma conta' : 'Clique em pesquisar'}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          {!contaSelecionada 
                            ? 'Escolha uma conta bancária e clique em pesquisar para visualizar os lançamentos'
                            : 'Selecione uma conta e clique no botão de pesquisa para visualizar os lançamentos'}
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : rows.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center" sx={{ py: 8 }}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                        <SearchOffIcon sx={{ fontSize: 64, color: (theme) => theme.palette.grey[400] }} />
                        <Typography variant="h6" color="textSecondary">
                          Nenhum lançamento encontrado
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Não há registros para a conta {conta} no período de {dataInicial} a {dataFinal}
                        </Typography>
                        <Button 
                          variant="outlined" 
                          size="small" 
                          onClick={() => handlePesquisa(dayjs(dataInicial, 'DD/MM/YYYY'), dayjs(dataFinal, 'DD/MM/YYYY'))}
                          sx={{ mt: 1 }}
                        >
                          Pesquisar novamente
                        </Button>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  rows.map(row => (
                    <TableRow key={row.idcaixa} 
                      hover
                      sx={{ cursor: 'pointer' }}  
                    >
                      <TableCell sx={{ py: 0.5 }}>
                        {(() => {
                          switch (row.tipos) {
                          case 1:
                            return <RequestPageIcon color='primary' fontSize='small'/>;
                          case 2:
                            return <RequestPageIcon color='error' fontSize='small'/>;
                          case 3:
                            return <CreditScoreIcon color='primary' fontSize='small'/>;
                          case 4:
                            return <CreditScoreIcon color='error' fontSize='small'/>;
                          case 5:
                            return <RepeatIcon color='primary' fontSize='small'/>;
                          case 6:
                            return <RepeatIcon color='error' fontSize='small'/>;
                          case 7:
                            return <EngineeringIcon color='error' fontSize='small'/>;
                          default:
                            return <MonetizationOnIcon color='inherit' fontSize='small'/>;
                          }
                        })()}
                      </TableCell>
                      <TableCell align='left' sx={{ py: 0.5, fontSize: '0.875rem' }}>{dayjs(row.datalan).format('DD/MM/YYYY')}</TableCell>
                      <TableCell align='center' sx={{ py: 0.5, fontSize: '0.875rem' }}>{row.numero}</TableCell>
                      <TableCell align='left' sx={{ py: 0.5, fontSize: '0.875rem' }}>{row.nome}</TableCell>
                      <TableCell align='left' sx={{ py: 0.5, fontSize: '0.875rem' }}>{row.historico}</TableCell>
                      <TableCell align='right' sx={{ py: 0.5, fontSize: '0.875rem' }}>{row.entrada.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2})}</TableCell>
                      <TableCell align='right' sx={{ py: 0.5, fontSize: '0.875rem' }}>{row.saida.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2})}</TableCell>
                      <TableCell sx={{ py: 0.5 }}>
                        {(() => {
                          switch (row.status) {
                          case true:
                            return <Switch size='small' checked={row.status} />;
                          case false:
                            return <IconButton color='error' aria-label="voltar lançamento" size="small">
                              <ReplyIcon fontSize='small' onClick={() => {handleVoltar(row.idoperacao, row.datalan, row.idconta, row.tipo);}} />
                            </IconButton>;
                          }
                        })()}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>   
            </Table>
          </Table>
        </TableContainer>
      </Box>
      
      
      <DialoFecharCaixa
        open={openFechar} 
        onClose={handleClose}
        idconta={contaSelecionada}
      /> 
      <DialogAbrirCaixa
        open={openAbrir} 
        onClose={handleClose}
        idconta={contaSelecionada}
      /> 
    </LayoutBaseDeFinanceiroConciliacao>
  ); 
};